import getCheapestPackageByDuration from 'lib/offer/getCheapestPackageByDuration'

interface Params {
  enableDurationSearch: boolean
  offer: App.Offer | App.OfferSummary
  duration: number | undefined
}

export function getCheapestPackageForDuration({
  enableDurationSearch,
  offer,
  duration,
}: Params): App.Package | null {
  if (!enableDurationSearch || duration === undefined) {
    return offer.lowestPricePackage ?? null
  }

  if (!Number.isFinite(duration)) {
    return null
  }

  return getCheapestPackageByDuration(offer.packages || [], duration) ?? null
}
